<style lang="stylus" scoped>
    .vipblock
        position relative
        min-width 228px
        padding 12px
        .vipblock-bg
            position absolute
            width 100%
            height 100%
            left 0
            top 0
            border-radius 8px
            overflow hidden
            &.blue
                background: linear-gradient(96.78deg, #EDF7FF 0%, #B0D4FF 100%)
            &.yellow
                background: linear-gradient(96.78deg, #FFF1D2 0%, #FFD17F 100%)
            &.black
                background: linear-gradient(104.04deg, #393938 0%, #1C1B1A 100%)
                &:after
                    content ""
                    position absolute
                    left 0
                    top 0
                    width 100%
                    height 100%
                    border-radius 8px
                    border: 1px solid;
                    border-image-source: linear-gradient(0deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05)), linear-gradient(180deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.02) 100%);
            .vipblock-mainbg
                position absolute
                right 0
                top 50%
                transform translateY(-50%)
            .vipblock-vip
                position absolute
                right 8px
                top 50%
                transform translateY(-50%)
        .vipblock-line
            position relative
            display flex
            align-items center
            column-gap 8px
            &:not(:last-child)
                margin-bottom 16px
            .vipblock-title
                font-size 14px
                font-weight 700
                color #222
                line-height 18px
                width max-content
                word-break break-all
                &.black
                    color #FFD48F
                    padding-right 40px
                &.yellow
                    color #632400
                svg
                    width 20px
                    height 20px
                    flex-shrink 0
                    margin-bottom -4px
                    margin-right 4px
            .vipblock-upgrade
                min-width 56px
                height 24px
                padding 0 8px
                display flex
                align-items center
                justify-content center
                border-radius 4px
                color #fff
                font-size 12px
                user-select none
                cursor pointer
                flex-shrink 0
                margin-left auto
                &.blue
                    background var(--themeColor)
                    &:hover
                        background var(--themeHover)
                &.yellow
                    background #632400
                    color #FFD298
                    &:hover
                        background #4b1c01

            .vipblock-content
                display flex
                line-height 16px
                column-gap 8px
                font-size 12px
                line-height 16px
                white-space nowrap
                &.blue
                    color #222
                &.yellow
                    color #632400
                &.black
                    color #FFD48F
            .vipblock-refresh
                width 20px
                height 20px
                cursor pointer
                margin -2px
                padding 2px
                border-radius 4px
                &:hover
                    background rgba(0,0,0,.08)
                svg
                    width 16px
                    height 16px
                &.black
                    color #222
                &.yellow
                    color #632400
</style>

<template>
    <div class="vipblock">
        <div class="vipblock-bg" :class="{ blue: role == 'normal' || role == 'expire', yellow: role == 'vip', black: role == 'fvip' }">
            <img class="vipblock-mainbg" :src="imgBg" alt="" />
            <img v-if="role == 'fvip'" class="vipblock-vip" src="@/public/components/userMenu/assets/vip.png" alt="" />
        </div>
        <div class="vipblock-line">
            <p class="vipblock-title" :class="{ yellow: role == 'vip', black: role == 'fvip' }">
                <svg v-if="['vip', 'fvip'].includes(role)" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.68097 16.5H14.3168C15.1116 16.5 15.7821 15.9098 15.889 15.1202L17.5743 7.16586C17.6909 6.27856 16.6375 5.73329 15.9846 6.3411L14.2141 7.98865C13.8177 8.35999 13.1919 8.3209 12.8421 7.90657L10.7257 3.83713C10.3448 3.38762 9.65295 3.38762 9.27399 3.83713L7.15762 7.90657C6.8078 8.3209 6.18203 8.35803 5.78557 7.98865L4.01513 6.3411C3.36215 5.73329 2.30882 6.28052 2.42542 7.16586L4.1107 15.1202C4.21564 15.9098 4.88612 16.5 5.68097 16.5ZM6.80993 11.1875L9.42534 13.8029L9.99986 14.3775L10.5744 13.8029L13.1898 11.1875L12.0407 10.0385L9.99986 12.0794L7.95898 10.0385L6.80993 11.1875Z"
                        fill="currentColor"
                    />
                </svg>
                <span>{{ $t(userTitle) }}</span>
            </p>
            <div
                class="vipblock-upgrade"
                :class="{ blue: role == 'normal' || role == 'expire', yellow: role == 'vip' }"
                v-if="role != 'fvip'"
                @click="toVip"
            >
                {{ $t("upgrade") }}
            </div>
        </div>
        <div class="vipblock-line">
            <p class="vipblock-content" :class="{ blue: role == 'normal' || role == 'expire', yellow: role == 'vip', black: role == 'fvip' }">
                <template v-if="role == 'normal'">
                    <i18n path="freeDate" tag="span">
                        <span>{{ regTime }}</span>
                    </i18n>
                </template>
                <template v-else-if="role == 'expire'">
                    <i18n path="expireDate" tag="span">
                        <span>{{ expireDate }}</span>
                    </i18n>
                </template>
                <template v-else-if="role == 'vip'">
                    <i18n path="vipDate" tag="span">
                        <span>{{ vipExpireDate }}</span>
                    </i18n>
                </template>
                <template v-else-if="role == 'fvip'">
                    <i18n path="fvipDate" tag="span">
                        <span>{{ regTime }}</span>
                    </i18n>
                </template>
            </p>
            <div
                class="vipblock-refresh"
                v-if="role != 'fvip'"
                :class="{ black: role == 'normal' || role == 'expire', yellow: role == 'vip' }"
                @click="refreshVip"
            >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.0729 2.76795L13.4512 6.18724L10.0077 5.56096" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
                    <path
                        d="M13.1251 10C12.325 12.0487 10.332 13.5 8 13.5C4.96243 13.5 2.5 11.0376 2.5 8C2.5 4.96243 4.96243 2.5 8 2.5C10.332 2.5 12.325 3.95132 13.1251 6"
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";

    @Component
    export default class Vipblock extends Vue {
        get imgBg() {
            const color = { normal: "blue", expire: "blue", vip: "yellow", fvip: "black" }[this.role];
            return require(`@/public/components/userMenu/assets/${color}.png`);
        }
        get imgUrl() {
            return "@/public/components/userMenu/assets/normal.png";
        }
        get userTitle() {
            const data = { normal: "free", expire: "free", vip: "vip", fvip: "fvip" }[this.role];
            return data;
        }

        get role() {
            if (!this.vip) {
                return this.expireDate != 0 ? "expire" : "normal";
            } else {
                return this.$store.state.publicStore.fuser ? "fvip" : "vip";
            }
        }
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        get regTime() {
            const timeDifference = this.userInfo._current - this.userInfo.reg_time;
            return Math.ceil(timeDifference / (60 * 60 * 24));
        }
        get expireDate() {
            return this.$store.state.publicStore.expireDate;
        }
        get vipExpireDate() {
            return this.$store.state.publicStore.vipExpireDate;
        }
        toVip() {
            this.$openBuyPage("cloudSpaceLeftBottom");
        }
        block = false;
        refreshVip() {
            if (this.block) return;
            this.block = true;
            let parama = this.$store.getters.apiParam;
            this.$store
                .dispatch("updateVipStatus", {
                    user_id: parama.id,
                    token: parama.token,
                })
                .finally(() => {
                    this.block = false;
                });
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "free": "个人免费版",
        "vip": "尊贵的订阅会员",
        "fvip": "尊贵的终身会员",
        "freeDate": "已免费试用{0}天",
        "expireDate": "会员已过期{0}天",
        "vipDate": "{0}到期",
        "fvipDate": "亿图图示已为您服务{0}天",
        "upgrade": "升级"
    },
    "en": {
        "free": "Individual Free Trial",
        "vip": "Dear Subscriber",
        "fvip": "Dear Lifetime Member",
        "freeDate": "Free trial for {0} days",
        "expireDate": "Premium has expired {0} days",
        "vipDate": "Expire on {0}",
        "fvipDate": "EdrawMax has been serving you for {0} days",
        "upgrade": "Upgrade"
    },
    "fr": {
        "free": "Essai gratuit pour les particuliers",
        "vip": "Cher abonné/Chère abonnée",
        "fvip": "Cher adhérent/Chère adhérente à vie",
        "freeDate": "Essai gratuit pendant {0} jour(s)",
        "expireDate": "La version Premium a expiré il y a {0} jours.",
        "vipDate": "Expire le {0}",
        "fvipDate": "EdrawMax vous accompagne depuis {0} jour(s).",
        "upgrade": "Passer à Premium"
    },
    "de": {
        "free": "Individuelle kostenlose Testversion",
        "vip": "Liebe Abonnentin, lieber Abonnent",
        "fvip": "Liebes Mitglied des lebenslangen Abonnements",
        "freeDate": "{0} Tag(e) kostenlos nutzen",
        "expireDate": "Der Premium-Plan ist seit {0} Tagen abgelaufen",
        "vipDate": "Läuft am {0} ab",
        "fvipDate": "Sie nutzen EdrawMax seit {0} Tagen",
        "upgrade": "Upgraden"
    },
    "jp": {
        "free": "個人向け無料体験",
        "vip": "登録者の皆さん",
        "fvip": "永続メンバーの皆さん",
        "freeDate": "{0}日間無料体験",
        "expireDate": "プレミアムの期限が{0}日前に切れています",
        "vipDate": "{0}まで有効",
        "fvipDate": "EdrawMaxのご利用期間が{0}日になりました",
        "upgrade": "アップグレード"
    },
    "es": {
        "free": "Prueba individual gratuita",
        "vip": "Estimado suscriptor",
        "fvip": "Estimado miembro de por vida",
        "freeDate": "Prueba gratuita durante {0} días.",
        "expireDate": "La versión Premium ha caducado hace {0} días.",
        "vipDate": "Caduca el {0}",
        "fvipDate": "Has utilizado EdrawMax durante {0} días.",
        "upgrade": "Actualizar a Premium"
    },
    "pt": {
        "free": "Avaliação gratuita individual",
        "vip": "Prezado assinante",
        "fvip": "Prezado membro vitalício",
        "freeDate": "Avaliação gratuita por {0} dia(s)",
        "expireDate": "A versão Premium expirou há {0} dia(s)",
        "vipDate": "Expira em {0}",
        "fvipDate": "O EdrawMax está atendendo você há {0} dia(s)",
        "upgrade": "Upgrade para Premium"
    },
    "it": {
        "free": "Versione di prova gratuita individuale",
        "vip": "Abbonato prestigioso",
        "fvip": "Gentile abbonato alla versione a vita",
        "freeDate": "Versione di prova gratuita da {0} giorni",
        "expireDate": "Premium è scaduto da {0}",
        "vipDate": "Scadenza il {0}",
        "fvipDate": "EdrawMax è al tuo servizio da {0} giorni.",
        "upgrade": "Passa a Premium"
    }
}
</i18n>
